<div class="modal-header">
  <button type="button" (click)="onNoClick()" class="close" data-dismiss="modal" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div mat-dialog-content>
  <div class="row">
    <div class="col-lg-8 col-md-8 col-sm-8 ml-auto mr-auto">
      <form (ngSubmit)="onSignin(f)" #f="ngForm">
        <div class="card card-login card-hidden">
          <div class="card-header card-header-success text-center">
            <h4 class="card-title">Ingresa tus credenciales</h4>

          </div>
          <div class="card-body ">

            <span class="bmd-form-group">

            </span>
            <span class="bmd-form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="material-icons">person</i>
                  </span>
                </div>
                <input #usuario type="text" id="usuario" name="usuario" ngModel class="form-control"
                  placeholder="Usuario...">
              </div>
            </span>
            <span class="bmd-form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="material-icons">lock_outline</i>
                  </span>
                </div>
                <input #password type="password" id="password" name="password" ngModel class="form-control"
                  placeholder="Contraseña...">
              </div>
            </span>
          </div>
          <div class="card-footer justify-content-center">
            <button class="btn btn-success  btn-lg" type="submit" [disabled]="!f.valid">Aceptar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>